// from here https://developers.google.com/recaptcha/docs/faq#id-like-to-run-automated-tests-with-recaptcha.-what-should-i-do
export const GOOGLE_SITE_KEY_LOCAL = '6LecKPYjAAAAAOfgM2GVDJX15x_AQ3GSRXxBEKHg'
